<section id="main" class="bg-light">

     <div id="userAccountAdminContainer" class="container">
          <div class="overlay" *ngIf="isLoading">
               <h1 [innerHtml]="'Processing' | translator: 'base'" class="heading">Processing...</h1>
               <img alt="Loading" />
          </div>
          <h1 [innerHtml]="'UAAHeader' | translator:'customer'">User
               Account
               Admin
          </h1>
          <p [innerHtml]="'enableUserTxt' | translator:'customer'">
               From this page, existing users can only be disabled. If you disable a user in error, please reach out to customer
               support for assistance. They can be reached at <a href="mailto:PSPhelp@tylertech.com" title="PSPhelp@tylertech.com">
               PSPhelp&#64;tylertech.com</a> or at <a href="tel:1-877-642-9499" title="1-877-642-9499">1-877-642-9499</a>
               <br><br>
               If you need to make user or account updates, please complete and return the applicable form found below in the 
               Change Request Forms section. Completed and signed forms can be sent via email to the above email address or by fax at
               <a href="tel:1-703-841-6370" title="1-703-841-6370">1-703-841-6370</a> and may take up to 48 hours to process.
          </p>
          <div class="row">
               <div class="col-12">
                    <h2 class="h4" [innerHtml]="'Users' | translator:'customer'">Users
                    </h2>
                    <div class="row justify-content-between">
                         <div class="col-12 col-sm-6 searchEdit mb-3">
                              <input [(ngModel)]="filterString" type="text" (keyup)="filterList()"
                                   class="form-control form-control-search"
                                   [placeholder]="'UserSearchInput' | translator:'customer'"
                                   [title]="'UserSearchInput' | translator:'customer'" />
                         </div>
                         <div class="col-auto d-flex align-items-center text-right mb-3">
                              <label for="pageSize" class="form-label mb-0 me-2"
                                   [innerHtml]="'View' | translator:'driver'">View</label>
                              <select [(ngModel)]="pageSize" (change)="onPageSizeChanged()" id="pageSize"
                                   name="pageSize" class="form-select">
                                   <option value="10" selected>10</option>
                                   <option value="25">25</option>
                                   <option value="50">50</option>
                                   <option value="100">100</option>
                                   <option value="250">250</option>
                              </select>
                         </div>
                    </div>
                    <div class="card shadow-sm rounded-0 border-0 mb-3">
                         <div class="card-body">
                              <div role="table" aria-label="List of users">
                                        <div class="row row-body mx-0 d-none d-md-flex" role="row">
                                             <div class="col-12 col-md-5 d-none d-md-flex" role="columnheader">
                                                  <span class="row-header"
                                                       (click)="sortOnInfo = (sortOnInfo !== 'name_down' ?  'name_down' : 'name_up');filterList();" 
                                                       role="button" 
                                                       tabindex="0"
                                                  >
                                                       User
                                                       <span [innerHtml]="'Name' | translator:'base'"
                                                            [title]="'Name' | translator:'base'">
                                                       </span>
                                                       <i *ngIf="sortOnInfo === 'name_down'" class="fa fa-angle-down ms-2"
                                                            aria-hidden="true"></i>
                                                       <i *ngIf="sortOnInfo === 'name_up'" class="fa fa-angle-up ms-2"
                                                            aria-hidden="true"></i>
                                                  </span>
                                             </div>
                                             <div class="col-12 col-md-3 d-none d-md-flex" role="columnheader">
                                                  <span class="row-header"
                                                       (click)="sortOnInfo = (sortOnInfo !== 'last_down' ?  'last_down' : 'last_up');filterList();"
                                                       role="button" 
                                                       tabindex="0"
                                                  >
                                                       <span [innerHtml]="'lastLoginHeader' | translator:'customer'"
                                                            [title]="'lastLoginHeader' | translator:'customer'"></span>
                                                       <i *ngIf="sortOnInfo === 'last_down'" class="fa fa-angle-down ms-2"
                                                            aria-hidden="true"></i>
                                                       <i *ngIf="sortOnInfo === 'last_up'" class="fa fa-angle-up ms-2"
                                                            aria-hidden="true"></i>
                                                  </span>
                                             </div>
                                             <div class="col-12 col-md-4 d-none d-md-flex" role="columnheader">
                                                  <span class="sr-only">Actions</span>
                                             </div>
                                        </div>

                                        <div class="row row-body mx-0 justify-content-center align-items-center userRos"
                                             *ngFor="let user of viewList;" role="row">
                                             <div class="col-12 col-md-5 text-break" role="cell" [title]="user.username">
                                                  <span class="fw-bold d-inline-block d-md-none me-3" 
                                                  [innerHtml]="'Username' | translator:'base'"
                                                  >User Name</span>
                                                  {{user.username}}
                                             </div>
                                             <div  [title]="(user.lastLoginDate!.toString() | dateTimeFromIso | dateTimeToLocaleString)"
                                                  *ngIf="user.lastLoginDate !== null" 
                                                  class="col-12 col-md-3" 
                                                  role="cell"
                                             >
                                                  <span class="fw-bold d-inline-block d-md-none me-3" [title]="''" role="cell">Last Login</span>
                                                  {{user.lastLoginDate!.toString() | dateTimeFromIso | dateTimeToLocaleString }}
                                             </div>
                                             <div *ngIf="user.lastLoginDate === null" class="col-12 col-md-3 d-flex align-items-center p-0" [title]="''" role="cell"></div>
                                             <div class="col-12 col-md-4 d-flex align-items-center" role="cell">
                                                  <div class="d-flex justify-content-end">
                                                       <button class="btn btn-primary btn-sm"
                                                            (click)="edit(user.username)"
                                                            [innerHtml]="'Edit' | translator:'base'"
                                                            [title]="'Edit' | translator:'base'">Edit</button>
                                                       <button *ngIf="user.isEnabled === true && !isPowerUser(user.email) && !isBillingUser(user.email) && !isAuditUser(user.email, user.username)"
                                                            class="btn btn-outline-primary btn-sm ms-3"
                                                            [innerHtml]="'disableButton' | translator:'customer'"
                                                            [title]="'disableButton' | translator:'customer'"
                                                            (click)="disable(user.username,user.email,user)">Disable</button>

                                                       <span *ngIf="isPowerUser(user.email)" class="fst-italic ms-3 pt-1"
                                                            [innerHtml]="'powerUserText' | translator:'customer'"
                                                            [title]="'powerUserText' | translator:'customer'">Power User</span>
                                                            
                                                       <span *ngIf="isBillingUser(user.email)" class="fst-italic ms-3 pt-1"
                                                            [innerHtml]="'billingUserText' | translator:'customer'"
                                                            [title]="'billingUserText' | translator:'customer'">Billing User</span>

                                                       <span *ngIf="isAuditUser(user.email, user.username)" class="fst-italic ms-3 pt-1"
                                                            [innerHtml]="'auditContactText' | translator:'customer'"
                                                            [title]="'auditContactText' | translator:'customer'">Audit Contact</span>

                                                       <span *ngIf="user.isEnabled === false
                                                       && !isPowerUser(user.email) && !isBillingUser(user.email) && !isAuditUser(user.email, user.username)
                                                       " class="fst-italic ms-3 pt-1"
                                                            [innerHtml]="'DisabledTxt' | translator:'customer'"
                                                            [title]="'DisabledTxt' | translator:'customer'">Disabled</span>
                                                  </div>
                                             </div>
                                        </div>

                                        <div class="row justify-content-center mt-2" role="row">
                                             <div class="col-12 d-flex justify-content-end flex-wrap" role="cell">
                                                  <span class="d-flex align-items-center">
                                                       <span id="first-row" ref="lbFirstRowOnPage"
                                                            class="boldNumber">{{recored_X_To}}</span>
                                                       <span id="to-row" class="page-of"
                                                       [innerHtml]="'to_grid' | translator:'base'"
                                                       [title]="'to_grid' | translator:'base'">to</span>
                                                       <span id="last-row" ref="lbLastRowOnPage"
                                                            class="boldNumber">{{recored_X_To_Y}}</span>
                                                       <span id="of-row" class="page-of"
                                                       [innerHtml]="'of_grid' | translator:'base'"
                                                       [title]="'of_grid' | translator:'base'">of</span>
                                                       <span id="row-count" ref="lbRecordCount"
                                                            class="boldNumber">{{this._filteredLength}}</span>
                                                  </span>
                                                  <div class=" d-flex align-items-center">
                                                       <i aria-label="Fist Page" role="button" tabindex="0" (click)="setCurrentPage('f')"
                                                            [ngClass]="'fa fa-angle-double-left pagingIcons ' + (disableFirstPage ? 'pagingIconsDisabled' : 'paging_pointer')"></i>
                                                       <i aria-disabled="true" role="button" tabindex="0" (click)="setCurrentPage('p')"
                                                            aria-label="Previous Page"
                                                            [ngClass]="'fa fa-angle-left pagingIcons ' + (disablePreviousPage ? 'pagingIconsDisabled' : 'paging_pointer')"></i>
                                                       <span>
                                                            <span id="start-page" style="margin-left: 8px;"
                                                            [innerHtml]="'page_grid' | translator:'base'">Page</span>
                                                            <span id="start-page-number" style="padding-left: 8px;"
                                                                 ref="lbCurrent"
                                                                 class="boldNumber">{{currentPage}}</span>
                                                            <span id="of-page" class="page-of"
                                                            [innerHtml]="'of_grid' | translator:'base'">of</span>
                                                            <span id="page-number" ref="lbTotal"
                                                                 class="boldNumber">{{totalPages}}</span>
                                                       </span>

                                                       <i aria-disabled="true" aria-label="Next Page"
                                                       role="button" tabindex="0" [ngClass]="'fa fa-angle-right pagingIcons ' + (disableNextPage ? 'pagingIconsDisabled' : 'paging_pointer')"
                                                            (click)="setCurrentPage('n')"></i>
                                                       <i aria-disabled="true" aria-label="Last Page"
                                                       role="button" tabindex="0" [ngClass]="'fa fa-angle-double-right pagingIcons ' + (disableLastPage ? 'pagingIconsDisabled' : 'paging_pointer')"
                                                            (click)="setCurrentPage('l')"></i>
                                                  </div>
                                             </div>
                                        </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
          <div class="row">
               <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <div class="card shadow-sm rounded-0 border-0 h-100">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0" 
                                   [innerHtml]="'ChangeRequestForms' | translator:'customer'">Change Request Forms</h2>
                              <p>
                                   <a [href]="updateUrl('##docBaseUrl##/Change_Req_Users.pdf')" 
                                        class="btn btn-primary" 
                                        target="_blank"
                                        [title]="'ModifyUsersButtonTitle' | translator:'customer'" id="modifyUsers"
                                        name="modifyUsers" role="button">
                                        <span [innerHtml]="'ModifyUsersButtonText' | translator:'customer'">Modify
                                             Users</span> (PDF)
                                   </a>
                              </p>
                              <p>
                                   <a [href]="updateUrl('##docBaseUrl##/Change_Req_Billing.pdf')" 
                                        class="btn btn-primary" 
                                        target="_blank"
                                        [title]="'ModifyBillingButtonText' | translator:'customer'" id="modifyBilling"
                                        name="modifyBilling" role="button">
                                        <span [innerHtml]="'ModifyBillingButtonText' | translator:'customer'">Modify
                                             Billing</span> (PDF)
                                   </a>
                              </p>
                              <p class="mb-0">
                                   <a [href]="updateUrl('##docBaseUrl##/Change_Request_Account.pdf')" 
                                        class="btn btn-primary" 
                                        target="_blank"
                                        [title]="'ModifyAccountButtonTitle' | translator:'customer'" id="modifyAccount"
                                        name="modifyAccount" role="button">
                                        <span [innerHtml]="'ModifyAccountButtonText' | translator:'customer'">Modify
                                             Account</span> (PDF)
                                   </a>
                              </p>
                         </div>
                    </div>
               </div>
               <div class="col-12 col-md-6">
                    <div class="card shadow-sm rounded-0 border-0 h-100">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0" 
                                   [innerHtml]="'UsefulTips' | translator:'customer'">Useful Tips</h2>
                              <ul>
                                   <li [innerHtml]="'UsefulTipsBullet2' | translator:'customer'">
                                        Click the <i>Disable</i> button to remove PSP access.
                                   </li>
                                   <li [innerHtml]="'UsefulTipsBullet3' | translator:'customer'">
                                        Use the <i>Modify Users</i> button to add or remove users.
                                   </li>
                              </ul>
                              <a href="http://get.adobe.com/reader/" target="_blank" rel="noopener noreferrer"
                                   [title]="'DownloadPDFLinkText' | translator:'base'" class="btn btn-outline-primary btn-sm" role="button">
                                   <span [innerHtml]="'DownloadPDFLinkText' | translator:'base'">Click to download a
                                        free PDF
                                        viewer</span>
                              </a>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <ngb-toast *ngIf="showToast" [autohide]="false" (hidden)="showToast=false">
          <ng-template ngbToastHeader>
               <div class="me-auto">
                    <strong *ngIf="toastIsError" class="mx-1"><span
                              [innerHtml]="'DisableErrorMessage' | translator:'customer'"></span>{{this.disableUsername}}</strong>
                    <strong *ngIf="!toastIsError" class="mx-1"><span
                              [innerHtml]="'DisableSuccessMessage' | translator:'customer'"></span>{{this.disableUsername}}</strong>
               </div>
          </ng-template>
          <span *ngIf="toastIsError" [innerHtml]="'Error' | translator:'base'"></span>
          <span *ngIf="!toastIsError" [innerHtml]="'Success' | translator:'customer'"></span>
     </ngb-toast>
     <ng-template #disableModal let-modal>
          <div class="modal-header">
               <h3 
                    id="disableModalTitle" 
                    class="modal-title" 
                    slot="header" 
                    [innerHtml]="'DisableModalTitle' | translator:'customer'"
               >
                    Disable User
               </h3>
          </div>
          <div class="modal-body">
               <div slot="body">
                    <span [innerHtml]="'DisableConfirm' | translator:'customer'">
                         Are you sure you want to disable </span><strong>{{ disableUsername }}?</strong>
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary ms-2" [title]="'ok_button' | translator:'base'" name="okay" id="okay"
                    (click)="disableUser()">
                    <span [innerHtml]="'ok_button' | translator:'base'">Ok</span>
               </button>
               <button class="btn btn-outline-primary" (click)="cancelDisable()"
                    [title]="'cancel_button' | translator:'base'" id="cancelDisable" name="cancelDisable">
                    <span [innerHtml]="'cancel_button' | translator:'base'">Cancel</span>
               </button>
          </div>
     </ng-template>

     <ng-template #showRestrictedUserModal let-modal>
          <div class="modal-header">
               <h3 
                    id="showRestrictedUserModalTitle" 
                    class="modal-title" slot="header" 
                    [innerHtml]="'restictedUserModalTitle' | translator:'customer'"
               >
                    Restricted User
               </h3>
          </div>
          <div slot="body">
               <div class="modal-body">
                    <span>
                         <span 
                              [innerHtml]="'PowerUserNoDisabled' | translator:'customer'">The Power User cannot be
                              disabled. Please submit a Modify Users Change Request Form to add a new power user and
                              disable</span> {{ restrictedUsername }}.
                    </span>
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" [title]="'ok_button' | translator:'base'" name="okay" id="okay"
                    (click)="closeRestrictedUserModal()">
                    <span [innerHtml]="'ok_button' | translator:'base'">Ok</span>
               </button>
          </div>
     </ng-template>
</section>